<template>
  <!-- Material form login -->
  <form class="signin">



    <h5 class="text-muted">Please sign in</h5>
    <div class="form-floating">
      <input type="email" class="form-control " v-model="email" id="floatingInput" placeholder="name@example.com">
      <label for="floatingInput">Username</label>
    </div>
    <p class="mt-1 mb-1 text-muted"></p>
    <div class="form-floating">
      <input type="password" class="form-control" v-model="password" id="floatingPassword" placeholder="Password">
      <label for="floatingPassword">Password</label>
    </div>

    <p class="mt-2 mb-3 text-muted"></p>
    <button class="w-100 btn btn-lg btn-dark mt-2" @click.prevent="login">Sign in</button>
  </form>
  <!-- Material form login -->
</template>

<script>
  /* eslint-disable */
  import Api from './api'
  export default{
    data(){
      return{
        email:'',
        password:''
      }
    },
    methods:{
      login(){
        let that = this
          Api.auth.login({"username": this.email, "password": this.password})
              .then(response => response.data)
              .then(data => {
                  Api.init(data.accessToken)
                  that.$cookies.set("authToken", data.accessToken)
                  localStorage.setItem("authToken", data.accessToken)
                  this.$router.push({ path: 'labels' })
              })
              .catch(error => {
                  throw error
              });

      }
    },
    beforeMount(){
      let jwt = this.$cookies.get("authToken")
      Api.auth.verify({authToken: jwt})
              .then(response => {
                if(response.status == 200){
                    this.$store.commit('setUser', true)
                    Api.init(jwt)
                    this.$router.push({ path: '/labels' })
                }
              })
              .catch(err =>{
                this.$store.commit('setUser', false)
                this.$router.push({ path: '/' })
              })
    }
  }
</script>

<style>

  body {
    margin: 0;
    font-family: var(--bs-font-sans-serif);
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    background-color: lightgray;
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: transparent;
  }
.signin{
  border: 1px solid #ced4da;
  border-radius: 2%;
  background-color: white;
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: auto;
  margin-top: 50px;
}
</style>
